module.exports = __webpack_public_path__ + "img/Z60_14.2e17439f.jpg";